import { UpdateService } from './update.service';
import { Injectable, EventEmitter } from '@angular/core';
import { ISubscription } from 'rxjs/Subscription';

@Injectable()
export class DataService {
  public date = (Date.now() - 49000 * (60 * 60 * 24 * 365.24255)) * 1000;
  public maxEnergy = 100;
  public currentEnergy = 100;
  public maxSatiety = 60;
  public currentSatiety = 60;
  public maxHealth = 100;
  public currentHealth = 100;

  public food = 0;
  public materials = 0;
  public tools = 0;
  public shelter = 0;

  public hasDied = new EventEmitter;

  private sub: ISubscription;

  constructor(private updateService: UpdateService) {
    this.sub = updateService.loop$.subscribe(({ interval, value }) => {
      this.date += 1000 * interval;

      if (this.currentEnergy < this.maxEnergy) {
        this.currentEnergy += interval / 5000;
      } else {
        this.currentEnergy = this.maxEnergy;
      }

      if (this.currentSatiety > 0) {
        this.currentSatiety -=  interval / 1440;
      } else {
        this.currentSatiety = 0;
        this.hasDied.emit(true);
        // this.maxHealth reduces by some amount..
      }

      if (this.currentHealth > this.maxHealth) {
        this.currentHealth = this.maxHealth;
      }

    });
  }
}



// WEBPACK FOOTER //
// C:/Users/HeinousTugboat/Projects/survivalism/src/app/core/data.service.ts